export default {
  'ACTIVEWEAR': 'Activewear',
  'CASUAL TOPS & JACKETS': 'Casual Tops & Jackets',
  'SWIMWEAR': 'Swimwear',
  'LOUNGEWEAR': 'Loungewear',
  'SHORTS': 'Shorts',
  'PANTS & TROUSERS': 'Pants & Trousers',
  'SKIRTS': 'Skirts',
  'BODY & JUMPSUITS': 'Body & Jumpsuits',
  'DRESSES': 'Dresses',
}
